const ENDPOINT = 'https://videos.miadvenio.com';
const CENTERS_PATH = `${ENDPOINT}/centers`
const CENTERS_VIDEOS_PATH = `${CENTERS_PATH}/videos`
export const S3_VIDEOS = 'https://videos-graducion-advenio.s3-us-west-2.amazonaws.com/';

const http = (url, requestOptions = {}) => fetch(url, requestOptions)
.then(response => {
    if (!response.ok) throw Error(response);

    return response.json();
});

export const getCenters = () => {
    return http(CENTERS_PATH);
}

export const getStudents = (centerId, page, classroomId) => {
    const url = `${CENTERS_PATH}/${centerId}/students?page=${page}&classroom=${classroomId}`;
    return http(url);
}

export const getClassrooms = (centerId) => {
    const url = `${CENTERS_PATH}/${centerId}/classrooms`;
    return http(url);
}

export const createCenterVideos = (id, students) => {
    const url = `${CENTERS_PATH}/${id}/generate`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(students)
    };
    return http(url, requestOptions);
}


export const getCentersVideos = (page) => {
    const url = `${CENTERS_VIDEOS_PATH}?page=${page}`;
    return http(url);
}

export const sendCenterVideos = (id) => {
    const url = `${CENTERS_VIDEOS_PATH}/${id}/send`;
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({})
    };
    return http(url, requestOptions);
}

export const deleteCenterVideos = (id) => {
    const url = `${CENTERS_VIDEOS_PATH}/${id}`;
    return http(url,{method: 'DELETE'});
}



// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/video-generator.service.js